import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';

import UserTrackItem from '../components/UserTrackItem';
import TrackList from '../components/TrackList';
import SyncData from '../components/SyncData';
import TrackMap from '../components/Track/Map';

import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { CircularProgress } from 'material-ui/Progress';

import { goBack } from '../helpers/Url';

import DocumentHelper from '../helpers/Document';

class TrackingContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            active_document: null
        }
    }

    componentDidMount() {
        const document_store = this.props.document_store;
        document_store.fetch({filter: {status: 'active'}}).catch(e => {
            console.error(e);
            alert('Falha ao recuperar os dados!');
        });
    }

    onRequestClose() {
        goBack(this.props.history);
    }

    onMapInit(map) {
        this.map = map;
    }

    onClickMarker(marker, document) {
        this.setState({ active_document: document });
    }

    onClickListItem(document) {
        const location = document.location;

        if (location) {
            const { latitude, longitude } = location;
            const position = { lat: latitude, lng: longitude };

            this.map.setCenter(position);
            this.map.setZoom(20);

            this.setState({active_document: document });
        } else {
            alert('Localização GPS não encontrada.');
        }
    }

    onRequestCloseUserTrackInfo() {
        this.setState({active_document: null });
    }

    render() {
        const document_store = this.props.document_store;
        const items = DocumentHelper.mapByStatus(document_store.documents, 'active');

        if (!document_store.is_fetched) {
            return (
                <div className="text-center" style={{marginTop: '36px'}}>
                    <div><CircularProgress /></div>
                    <p><small>Carregando...</small></p>
                </div>
            );
        }

        return (
            <div className="container-full tracking-delivery-container">
                <div className="close-btn">
                    <IconButton onClick={this.onRequestClose.bind(this)}>
                        <i className="material-icons">close</i>
                    </IconButton>
                </div>

                <TrackMap
                    id={document.id}
                    onMapInit={this.onMapInit.bind(this)}
                    onClickMarker={this.onClickMarker.bind(this)} />

                <div className="track-list">
                    <TrackList last_sync_at={document_store.updated_at} items={items} onItemClick={this.onClickListItem.bind(this)} />
                    <UserTrackItem last_sync_at={document_store.updated_at} document={this.state.active_document} onRequestClose={this.onRequestCloseUserTrackInfo.bind(this)} />
                    {<SyncData status="active" />}
                </div>
            </div>
        );
    }

}

let container = observer(TrackingContainer);
container = inject(['document_store'])(container);

export default withRouter(container);



// WEBPACK FOOTER //
// ./src/containers/tracking.js